import { FormikErrors } from 'formik';
import { isValidEmail } from '~/utils';

import { ContactLinkValues } from './ContactLink.types';

export const ContactLinkValidate = (fields: ContactLinkValues) => {
  let errors: FormikErrors<ContactLinkValues> = {};
  if (!isValidEmail(fields.email)) {
    errors.email = 'Must be a valid email';
  }
  if (!fields.email) {
    errors.email = 'Mandatory';
  }
  return errors;
};
